import React from 'react';
import {
  dimensions,
  ModuleDetailProps,
  ModuleHeader
} from '@bettermarks/bm-ui-components';
import {Module} from '../../types';
import styled from 'styled-components';
import {Flex} from '@chakra-ui/react';

const StyledModuleHeader = styled(ModuleHeader)`
  padding-left: 52px;
  box-shadow: none;
`;

export const BookHeader = (
  moduleIconAndColor: {color: string; icon: string},
  module: Module,
  chapterIntro: ModuleDetailProps
) => {
  return (
    <StyledModuleHeader
      color={moduleIconAndColor.color}
      title={module.name}
      margin={dimensions.spaceXl}
      objectives={
        chapterIntro.objectives.length > 0 ? chapterIntro.objectives : null
      }
      preknowledge={
        chapterIntro.preknowledge.length > 0 ? chapterIntro.preknowledge : null
      }
      image={`/topic-icons/${moduleIconAndColor.icon}`}
      imageSize={200}
      context='module'
    />
  );
};
